import { render, staticRenderFns } from "./ReportsHistory.vue?vue&type=template&id=2ac35897&scoped=true&"
import script from "./ReportsHistory.vue?vue&type=script&lang=js&"
export * from "./ReportsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac35897",
  null
  
)

export default component.exports